import services from './../../services/service'; // Service Class
import validate from './../../services/validation'; // Validator Class
import Commons from '../../resources/commons.js'; //Commons class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer

let service = new services();
let validator = new validate();

export default {
    name: 'Onboarding',
    mixins: [Commons],
    data () {
        return {
            user: {},
            group: {},
            group_details:{},
            group_shared_link:false,
            set_headers:{},
            loading: true,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        getGroup(){
            //set activity
            this.activity.activity_module_action_type = 6;
            //--set activity payload
            let data_payload = {
                data_id: this.group.ref_code, 
            }
            this.activity.activity_module_data = data_payload;

            //call activity
            this.getActivity();

            //get data
            let self = this;
            setTimeout(function(){
                localforage.getItem("activity_data_store", function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.group_details = value;
                        self.loading = false;
                        self.setGroup();
                    }else{}
                });
            },2000)
        },

        setGroup(){
            if(Object.keys(this.group_details).length > 0){
                localStorage.setItem('group',this.group_details.group_data.group_name);
                //store active group details in local forage
                if(Object.keys(this.group_details.group_data).length > 0){ 
                    localforage.setItem('active_group_data',this.group_details.group_data).then(function (value) {}).catch(function(err) {});
                }
            }
        },
       
    },
    created: function(){
        if((this.$route.params.gref != undefined) && (this.$route.params.gref != '')){
            this.group_shared_link = true;
            this.group.ref_code = this.$route.params.gref;
            this.group.name = this.$route.params.grname;
            this.set_headers.name = this.$route.params.grname;

            //store some params
            //--check user ref ref
            if((this.$route.params.ref != undefined) && (this.$route.params.ref != '')){
                localStorage.setItem('refcode',this.$route.params.ref);
            }
            localStorage.setItem('grefcode',this.$route.params.gref);

            //call get groups
            this.getGroup();
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/Onboarding/script.js